module.exports = __webpack_public_path__ + "static/media/GESTION.83698fa2.svg";